const extractCapitals = (string) => {
  const capitalLetters = string.match(/[A-Z]/g);
  if (capitalLetters) {
    return capitalLetters.join("");
  }
  return "";
};

export default extractCapitals;
